export const OPERATION_TYPES_PERMISSIONS = {
  SHOW_DATA: 'show_operation_types',
  CREATE_DATA: 'create_operation_types',
  EDIT_DATA: 'edit_operation_types',
  CHANGE_STATE_DATA: 'change_state_operation_types',
  DELETE_DATA: 'delete_operation_types',
  EXPORT_EXCEL: 'export_operation_types',
  IMPORT_EXCEL: 'import_operation_types',
} as const;
export const OPERATION_TYPES_PERMISSION_LIST = [
  OPERATION_TYPES_PERMISSIONS.SHOW_DATA,
  OPERATION_TYPES_PERMISSIONS.CREATE_DATA,
  OPERATION_TYPES_PERMISSIONS.EDIT_DATA,
  OPERATION_TYPES_PERMISSIONS.CHANGE_STATE_DATA,
  OPERATION_TYPES_PERMISSIONS.DELETE_DATA,
  OPERATION_TYPES_PERMISSIONS.EXPORT_EXCEL,
  OPERATION_TYPES_PERMISSIONS.IMPORT_EXCEL,
] as const;
